export const enrollmentConfirmation = {
  title: "¡Solicitud Enviada con Éxito!",
  subtitle: "Hemos recibido tu solicitud de preinscripción. Te contactaremos pronto para continuar con el proceso de admisión.",
  
  nextStepsTitle: "Próximos Pasos",
  steps: {
    step1: {
      title: "Revisión de tu solicitud",
      description: "Nuestro equipo revisará la información que nos has proporcionado. Te contactaremos en un plazo máximo de 48 horas laborables."
    },
    step2: {
      title: "Visita guiada personalizada",
      description: "Coordinaremos una visita a nuestras instalaciones donde podrás conocer nuestra metodología, equipo educativo y resolver todas tus dudas."
    },
    step3: {
      title: "Proceso de matrícula",
      description: "Si ambas partes estamos de acuerdo y hay plazas disponibles, procederemos con la formalización de la matrícula."
    }
  },
  
  contactTitle: "¿Necesitas Contactarnos?",
  contact: {
    phone: "Teléfono",
    email: "Email",
    address: "Dirección",
    hours: "Horario",
    hoursValue: "Lunes a Viernes, 8:45h - 14:00h"
  },
  
  scheduleVisit: "Reservar Visita",
  backToHome: "Volver al Inicio",
  
  note: "Si no recibes respuesta en 48 horas, por favor revisa tu carpeta de spam o contacta directamente con nosotros."
};